import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
import { TaxFragment } from 'graphql/Tax/fragments/TaxFragment';
/**
 * @fragment SaleItemForPickerFragment
 * @since 1.0.0
 */
export const SaleItemForPickerFragment = gql `
  fragment SaleItemForPickerFragment on SaleItem {
    id
    sku
    price
    cost
    inventory
    category
    configuration
    optionConfiguration
    active
    promoted
    taxable
    title
    summary
    infos
    deletedAt

    taxes {
      ...TaxFragment
    }

    relations {
      id
      type
      quantity
      saleItemId
      relatedSaleItemId
      saleItem {
        id
        title
        price
        sku
      }
      relatedSaleItem {
        id
        title
        price
        sku
      }
    }

    image {
      ...SaleItemImageFragment
    }

    images {
      ...SaleItemImageFragment
    }

    translations {
      id
      title
      summary
      infos

      language {
        ...LanguageFragment
      }
    }

    variants {
      id
      sku
      price
      inventory
      active

      options {
        id
        price
        quantity
        required
        included
        locked
        proposed
        recommended
        relations {
          id
          type
          quantity
          relatedSaleItem {
            id
            title
            price
            sku
          }
        }
        item {
          id
          sku
          title
          infos
          price
          active
          deletedAt
          relations {
            id
            type
            quantity
            relatedSaleItem {
              id
              title
              price
              sku
            }
          }
          group {
            id
            title
            order
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          groups {
            id
            title
            order
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }

          image {
            ...SaleItemImageFragment
          }
        }
      }

      values {
        id
        value
        field {
          ...FieldFragment
        }
      }

      fieldValues {
        id
        value
        field {
          ...FieldFragment
        }
      }
    }

    options {
      id
      price
      quantity
      required
      included
      locked
      proposed
      recommended
      relations {
        id
        type
        quantity
        saleItem {
          id
          title
          infos
          sku
          price
          taxable
          category
          configuration
          optionConfiguration
          group {
            id
            title
            order
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          groups {
            id
            title
            order
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          active
          promoted
          createdAt
          updatedAt
        }
        relatedSaleItem {
          id
          title
          infos
          sku
          price
          taxable
          category
          configuration
          optionConfiguration
          group {
            id
            title
            order
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          groups {
            id
            title
            order
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          active
          promoted

          relations {
            id
            type
            quantity
            saleItemId
            relatedSaleItemId
            saleItem {
              id
              title
              price
              sku
              active
            }
            relatedSaleItem {
              id
              title
              price
              sku
              active
            }
          }
        }
      }
      item {
        id
        title
        infos
        sku
        price
        taxable
        inventory
        category
        configuration
        optionConfiguration
        active
        deletedAt
        group {
          id
          title
          order
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        groups {
          id
          title
          order
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        active
        promoted
        relations {
          id
          type
          quantity
          relatedSaleItem {
            id
            title
            price
            sku
            active
          }
        }

        image {
          ...SaleItemImageFragment
        }
      }
    }

    fieldValues {
      value
      field {
        id
        name
        title
        infos
        visibility
        promote
        group {
          id
          category
        }
      }
    }

    packages {
      id
      included
      locked
      proposed

      package {
        id
        sku
        title
        infos
        price
        active
        icon
        deletedAt
        saleItems {
          id
          required
          item {
            id
            title
            price
          }
        }
      }
    }
  }

  ${LanguageFragment}
  ${SaleItemImageFragment}
  ${FieldFragment}
  ${TaxFragment}
`;
